$(".btn-menu").on("click", function(e) {
  e.preventDefault();
  const $nav = $(".nav");
  $nav.add($(this)).toggleClass("active");
  $nav.find("a, li, span").removeClass("active inactive");
  $nav.find(".submenu--deep2").hide();
  $(".header__utility .active").removeClass("active");
});

$(document).mouseup(function(e) {
  const $container = $(".nav, .btn-menu, .header");

  if (!$container.is(e.target) && $container.has(e.target).length === 0) {
    $container.removeClass("active");
    $container.find("a, li, span").removeClass("active inactive");
    $container.find(".submenu--deep2").hide();
    $(".header__utility .active").removeClass("active");
  }
});

$(".nav .menu > li > a").not(".no-dropdown").on("click", function(e) {
  e.preventDefault();
  const $this = $(this);
  const $li = $this.parent();
  const $menu = $this.closest(".menu");
  const menuOffsetTop = $menu.offset().top;
  const liOffsetTop = $li.offset().top;
  const offsetDiff = menuOffsetTop - liOffsetTop;

  $li
    .css({
      transform: `translateY(${offsetDiff}px)`
    })
    .toggleClass("active")
    .siblings("li")
    .add($(".nav__bottom"))
    .toggleClass("inactive");

  $(".nav").animate({
    scrollTop: 0
  });
});

$(".sub-toggle, .submenu a").on("click", function(e) {
  const $this = $(this);
  const $parent = $this.parent();

  if ($this.next(".sub-toggle").length) {
    e.preventDefault();
    $this.next(".sub-toggle").toggleClass("active");
  }

  $this.toggleClass("active");
  $parent.find(".submenu--deep2").slideToggle();
  $parent.siblings().find(".sub-toggle").removeClass("active").next("ul").slideUp();
});



// WEBPACK FOOTER //
// ../assets/js/nav.js